<template>
  <div :id="id" :class="computedClass">
    <v-icon v-if="swiftMove" color="white darken-2">verified</v-icon>
    <span v-if="swiftMove">&#160;</span>
    <slot />
  </div>
</template>

<script>
export default {
  props: ["id", "heading", "departmentId", "swiftMove"],
  computed: {
    computedClass() {
      return this.departmentId
        ? `sectionHeading${this.departmentId}`
        : undefined;
    }
  }
};
</script>
